import { createPathFromRoute } from 'assets/utils/dom/UrlParsing';
import executeServerApi from 'assets/utils/server/ServerApi';
import { getDefaultHeaders, HttpMethod } from 'config/Api.Config';

type Request = Api.Core.NonWarrantyPricePoint.Delete.IRequest;
type Response = Api.Core.NonWarrantyPricePoint.Delete.IResponse;
type Headers = Api.Core.NonWarrantyPricePoint.Delete.IHeaders;
const url = '/api/ProductManagement/NonWarrantyPricePoint/:id';
export default async function nonWarrantyPricePointDeleteApi(id: number): Promise<Api.Res<Response>> {
  const serverResponse = await executeServerApi<Request, Response, Headers>({
    method: HttpMethod.delete,
    url: createPathFromRoute(url, { id }),
    headers: getDefaultHeaders(),
  });
  return serverResponse;
}
